module.exports = __webpack_public_path__ + "img/teacher3.5fd80eae.png";